import { FC } from 'react';
import { H2, H2Container, H2Decorator, H5 } from './DecoratedTitle.styles';

interface DecoratedTitleProps {
	text: string;
	variant: 'h2' | 'h5';
}

const DecoratedTitle: FC<DecoratedTitleProps> = ({ text, variant }) => {
	if (variant === 'h2') {
		return (
			<H2Container>
				<H2>{text}</H2>
				<H2Decorator />
			</H2Container>
		);
	}

	if (variant === 'h5') {
		return <H5>{text}</H5>;
	}

	return null;
};

export default DecoratedTitle;
